import { useFormikContext } from 'formik';
import { DatePicker, ErrorContainer, LabelComponent } from 'components';
import dayjs from 'dayjs';

interface DateOfEncounterProps {
  disabled: boolean;
}

export const DateOfEncounter = ({ disabled }: DateOfEncounterProps) => {
  const formik = useFormikContext<{
    dateOfEncounter: string | null;
  }>();

  return (
    <>
      <LabelComponent mandatory text="Date of Encounter" />
      <DatePicker
        withGradient
        onChange={(date: string) => {
          formik.setFieldValue('dateOfEncounter', date).then(() => {
            formik.setFieldTouched('dateOfEncounter', true);
          });
        }}
        onBlur={(e: unknown) => formik.setFieldTouched('dateOfEncounter', true)}
        value={formik.values.dateOfEncounter}
        placeholder="MM/DD/YYYY"
        disabled={disabled}
        maxDate={dayjs()}
      />
      <ErrorContainer
        visible={formik.touched.dateOfEncounter && formik.errors.dateOfEncounter}
        errors={formik.errors}
        name="dateOfEncounter"
      />
    </>
  );
};
